<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="试卷">
                    <el-input v-model="query.keyword" placeholder="试卷标题" clearable></el-input>
                </el-form-item>
                <el-form-item label="用户">
                    <el-input v-model="query.keyword_user" placeholder="用户名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="考试时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                    <el-button type="success" icon="el-icon-search" @click="refresh">刷新</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="exam_answer_id" label="记录ID" width="80"></el-table-column>
                    <el-table-column prop="exam" label="试卷">
                        <template slot-scope="scope">
                            {{ scope.row.exam ? scope.row.exam.title : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="course" label="课程" width="200">
                        <template slot-scope="scope">
                            {{ scope.row.course ? scope.row.course.title : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="course" label="用户" width="150">
                        <template slot-scope="scope">
                            <el-image style="height: 40px" fit="contain" v-if="scope.row.user" class="ya-img-table" :src="scope.row.user.avatarUrl"
                                      :preview-src-list="[scope.row.user.avatarUrl]" title="点击查看大图" />
                            {{ scope.row.user ? scope.row.user.nickName : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_score" label="试卷总分" width="100"></el-table-column>
                    <el-table-column prop="get_score" label="考试得分" width="100"></el-table-column>
                    <el-table-column prop="right_count" label="答对题目数" width="100"></el-table-column>
                    <el-table-column prop="error_count" label="答错题目数" width="100"></el-table-column>
                    <el-table-column prop="error_count" label="是否全对" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.all_right  === 1 ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="考试时间" width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="130">
                        <template slot-scope="scope">
                            <el-button @click="handleDetail(scope.row)" type="text" size="small" v-auth="'/education/exam/examLogDetail'">详情</el-button>
<!--                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/exam/del'">删除</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
        <!--详情-->
        <detail ref="detail" @fetch-data="refresh"></detail>
    </div>
</template>

<script>
    import { examLog, examDel } from '@/api/education';
    import Detail from './detail';

    export default {
        components: {
            /*编辑组件*/
            Detail,
        },
        props: {
            user: Number,
            default: 0,
        },
        watch:{
            'props.user': {
                handler (newName, oldName) {
                    console.log(newName)
                    if(newName === 'undefined'){
                        this.query.user_id = ''
                    }
                    this.query.user_id = newName
                },
                immediate: true
            }
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                query: {
                    user_id: '',
                    create_time: '',
                    keyword: '',
                    keyword_user: '',
                    page: 1,
                    list_rows: 10,
                },
                select_type_array: [],

            };
        },
        created() {
            if(this.user > 0){
                this.query.user_id = this.user
            }
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                examLog(this.query).then((result)=>{
                    this.loading = false
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            // 详情
            handleDetail(row){
                this.$refs['detail'].showDialog(row)
            },
            // 删除
            handleDelete(row) {
                if (row.exam_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        examDel({ids: row.exam_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.exam_type = val
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/exam/answer/index.vue